import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function Season(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [value, setValue] = useState("");
  const [id, setId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadseasons();
  }, []);

  useEffect(() => {
    if (id !== props.id) {
      fetchedData.forEach((data) => {
        if (data.id === props.id) {
          setValue(data.label);
        }
      });
    }
  }, [props.id, fetchedData, id]);

  async function _loadseasons() {
    await NuxeoClient.instance()
      .fetchSeasons()
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (season) => {
    if (season !== null) {
      setValue(season[season.length - 1].label);
      setId(season[season.length - 1].id);
      props.handleChange("season", season[season.length - 1].id);
    } else {
      setValue("");
      setId(null);
      props.handleChange("season", null);
    }
  };

  return (
    // <Tooltip placement='top-start' title="Please enter the season.">
    <Tooltip placement="top-start" title={appText.T121}>
      <Grid item={true} xs={12}>
        <div id="season">
          <InputLabel className="label-test">
            {/* Seasons */}
            {appText.T58}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"season"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={value}
            isLoading={isLoading}
            isNotRequired={true}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
